/**
 * Minicart component
 *
 * @module component-minicart
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = 'component-minicart';

if (!customElements.get(customElements.component)) {

    class ComponentMinicart extends HTMLElement {

        /**
         * Minicart web component
         *
         * @constructor
         */
        constructor() {

            super();

            this.render();

            theme.cart.get().then(data => {
                this.update(data);
            });

            this.initEvents();
        }

        /**
         * Render component in the DOM
         *
         * @returns {undefined}
         */
        render() {

            let html = this.template();

            html = html.replace('{{ subtotal }}', '<div data-total-price></div>');
            html = html.replace('{{ shipping }}', '<div data-shipping-price></div>');


            this.innerHTML = html;

            this.dataset.ready =  true;

            //Set the height proportional to the items container
            setTimeout(() => {
                this.updateMiniCartHeight();
                this.listenDiscountCode();
            }, 300);
        }

        /**
         * Update height of components
         *
         * @returns {undefined}
         */
        updateMiniCartHeight() {

            //Set the height proportional to the items container
            let minicartFooter = this.querySelector("[data-content-footer]");
            let minicartHeader = this.querySelector("[data-content-header]");
            let minicartItems = this.querySelector("[data-content-items]");
            let sum = minicartFooter.offsetHeight + minicartHeader.offsetHeight;
            minicartItems.style.height = "calc(100vh - " + sum + "px)";
        }

        /**
         * Listen discount code accordion
         *
         * @returns {undefined}
         */
        listenDiscountCode() {

            let accordionButton = this.querySelector("[data-discount-code]");

            if(accordionButton) {

                accordionButton.addEventListener('click', () => {

                    // To avoid the issue with accordion behavior
                    setTimeout(() => {
                        this.updateMiniCartHeight();
                    }, 300);
                });
            }
        }

        /**
         * Update component
         *
         * @returns {undefined}
         */
        update(cart) {
            if (!cart) {return false}
            this.querySelector('[data-content-items]').innerHTML = '';
            this.updateMiniCartPrices(cart);

            // Your bag has products
            if (cart.item_count) {
                if (cart.items.length > 1) {
                    let indexItem = cart.items.findIndex(cartItem => cartItem.id === parseInt(this.productAdded?.id));
                    if (indexItem === -1) indexItem = 0; // Default to 0 if no match is found

                    this.addCartItem(cart.items[indexItem]);
                } else {
                    this.addCartItem(cart.items[0]);
                }
            }

            this.updateCounter(cart.item_count);
            this.checkMiniCartButtons(cart.item_count);
            this.updateMiniCartHeading(cart.item_count);
        }

        /**
         * Reload component
         *
         * @returns {undefined}
         */
        reload() {

            return new Promise((resolve, reject) => {

                theme.cart.get().then(data => {
                    this.update(data);
                    resolve(data);
                });
            });
        }

        /**
         * Add cart item into minicart
         *
         * @returns {undefined}
         */
        addCartItem(cartItem) {
            let html = `<minicart-item
                    data-fbt-product-url="${this.fbtProductURL}"
                    data-qty-added="${this.productAdded?.qty}"
                    id="${cartItem.id}">
                </minicart-item>
            `;

            this.querySelector('[data-content-items]').innerHTML = this.querySelector('[data-content-items]').innerHTML + html;
            const banner = this.querySelector('.bold_csp_qb_savings');
            if (banner) {
                this.querySelector('[data-content-items]').appendChild(banner);
            }
        }

        /**
         * Component template
         *
         * @returns {undefined}
         */
        template() {

            if (window.templateMinicart) {

                return window.templateMinicart;

            } else {

                return `
                    <side-drawer id="minicart_drawer" data-side="right" class="[&_.bold_csp_qb_savings]:hidden">
                        <form action="/cart" method="post" novalidate>
                            <div data-content-header class="py-4">
                                <div class="flex items-center content-center gap-2">
                                <div class="">
                                <svg width="24" height="24" viewBox="0 0 24 24" class="icon icon-cart {{ class }}" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2.25 3H3.636C4.146 3 4.591 3.343 4.723 3.835L5.106 5.272M5.106 5.272C10.6766 5.11589 16.2419 5.73515 21.642 7.112C20.818 9.566 19.839 11.95 18.718 14.25H7.5M5.106 5.272L7.5 14.25M7.5 14.25C6.70435 14.25 5.94129 14.5661 5.37868 15.1287C4.81607 15.6913 4.5 16.4544 4.5 17.25H20.25M6 20.25C6 20.4489 5.92098 20.6397 5.78033 20.7803C5.63968 20.921 5.44891 21 5.25 21C5.05109 21 4.86032 20.921 4.71967 20.7803C4.57902 20.6397 4.5 20.4489 4.5 20.25C4.5 20.0511 4.57902 19.8603 4.71967 19.7197C4.86032 19.579 5.05109 19.5 5.25 19.5C5.44891 19.5 5.63968 19.579 5.78033 19.7197C5.92098 19.8603 6 20.0511 6 20.25ZM18.75 20.25C18.75 20.4489 18.671 20.6397 18.5303 20.7803C18.3897 20.921 18.1989 21 18 21C17.8011 21 17.6103 20.921 17.4697 20.7803C17.329 20.6397 17.25 20.4489 17.25 20.25C17.25 20.0511 17.329 19.8603 17.4697 19.7197C17.6103 19.579 17.8011 19.5 18 19.5C18.1989 19.5 18.3897 19.579 18.5303 19.7197C18.671 19.8603 18.75 20.0511 18.75 20.25Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                </div>
                                    <div class="minicart_label">Cart</div>
                                    <h1 class="minicart_title items-center tracking-[-0.36px] text-white bg-orange-100 rounded-full px-2"><div class="text-xs ml-2 border rounded-xl py-[1px] px-[10px] bg-[#F15926] text-white" data-minicart-count></div></h1>
                                </div>
                                <div data-content-shipping>
                                    <free-shipping></free-shipping>
                                </div>
                            </div>
                            <div data-content-items class="overflow-y-auto"></div>
                            <div data-content-footer>
                                <div class="flex-col pt-4 hidden">
                                    <div class="flex pb-2 justify-between text-sm">
                                        <div>Shipping</div>
                                        {{ shipping }}
                                    </div>
                                    <div class="flex pb-4 justify-between font-semibold text-sm">
                                        <div>Order Subtotal</div>
                                        {{ subtotal }}
                                    </div>
                                </div>
                                <a href="/cart" class="btn-ghost bg-white border-[#DDDDDD] rounded-full flex justify-center items-center text-center w-full tracking-[-0.16px] mb-4 h-[40px]">View cart</a>
                                <button type="submit" class="cart-summary__checkout-button btn btn-icon-right  items-center w-full !flex mb-3" id="checkout" name="checkout">Checkout now <div class=" w-4 h-4 ml-2"><svg width="24" height="24" class="icon icon-lock-close {{ class }} !fill-none !stroke-white" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path  class"fill-white !stroke-white" d="M12 15V17M6 21H18C19.1046 21 20 20.1046 20 19V13C20 11.8954 19.1046 11 18 11H6C4.89543 11 4 11.8954 4 13V19C4 20.1046 4.89543 21 6 21ZM16 11V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7V11H16Z" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                </svg></div></button>
                            </div>
                        </form>
                    </side-drawer>
                `;
            }
        }

        /**
         * Init component events
         *
         * @returns {undefined}
         */
        initEvents() {
            window.addEventListener('addtocart', event => {
                if (document.body.classList.contains('template-cart')) return window.location = '/cart';

                this.productAdded = event.detail.productAdded;
                this.fbtProductURL = event.detail.productAdded.fbtProductURL || '';
                console.log('this.fbtProductURL:', this.fbtProductURL);

                this.reload().then(() => {
                    setTimeout(() => {
                        this.open();
                    },50);
                });
            });

            window.addEventListener('update', event => {
                this.updateMiniCartData(event);
            });

            window.addEventListener('remove', event => {
                this.updateMiniCartData(event);
            });

            // To avoid the issue with side drawer
            document.querySelectorAll('[data-drawer-target="minicart_drawer"]').forEach( element => {
                element.addEventListener('click', () => {
                    setTimeout(() => {
                        this.updateMiniCartHeight();
                    }, 100);
                });
            });

        }

        /**
         * Update minicart data
         *
         * @returns {undefined}
        */
        updateMiniCartData(event) {

            this.updateCounter(event.detail.cart.item_count);
            this.updateMiniCartPrices(event.detail.cart);

            // Your bag is empty
            if (!event.detail.cart.item_count) {
                this.checkMiniCartButtons(event.detail.cart.item_count);
                this.updateMiniCartHeading();
            }
        }

        /**
         * Open minicart
         *
         * @returns {undefined}
         */
        open() {

            this.querySelector('#minicart_drawer').open();

            // To avoid the issue with side drawer
            setTimeout(() => {
                this.updateMiniCartHeight();
            }, 100);
        }

        /**
         * Close minicart
         *
         * @returns {undefined}
         */
        close() {

            this.querySelector('#minicart_drawer').close();
        }

        /**
         * Update minicart counter
         *
         * @returns {undefined}
         */
        updateCounter(count) {

            document.querySelectorAll('[data-minicart-count]').forEach(element => {
                element.innerHTML = count;
                element.dataset.minicartCount = count;
            });
        }

        /**
         * Update minicart price
         *
         * @returns {undefined}
         */
        updateMiniCartPrices(cart) {

            // Set shipping price
            this.querySelector('[data-shipping-price]').innerHTML = window.theme.money.format(0);

            if(cart.item_count) {

                // Set total price
                this.querySelector('[data-total-price]').innerHTML = window.theme.money.format(cart.total_price);
            }
            else {

                // Set total price
                this.querySelector('[data-total-price]').innerHTML = window.theme.money.format(0);
            }
        }

        /**
         * Update minicart heading
         *
         * @returns {undefined}
         */
        updateMiniCartHeading(count) {


            let minicartHeader = this.querySelector("[data-content-header] h1");

            if(minicartHeader) {
                if(count) minicartHeader.innerHTML = `<div data-minicart-count="${count}">${count}</div>`;
                else minicartHeader.innerText = `Your Cart is empty`;
            }
        }

        /**
         * Enable view/edit cart button when cart has products
         *
         * @returns {undefined}
         */
        checkMiniCartButtons(count) {

            let carButton = this.querySelector('a[href="/cart"]');
            let checkoutButton = this.querySelector('#checkout');

            if(carButton) {
                if(count) carButton.classList.remove('hidden');
                else carButton.classList.add('hidden');
            }

            if(checkoutButton) {
                if(count) checkoutButton.disabled = false;
                else checkoutButton.disabled = true;
            }
        }
    }

    customElements.define(customElements.component, ComponentMinicart);
}
